'use strict';

const { documentReady } = require('@grpn/document-states');
const { extend } = require('underscore');

const { I18n } = window;
const gliveDealBookerInit = require('./initializers/deal/glive-booker');
const Timer = require('../../helpers/timer');

if (!window.BookingTemplates) {
  window.BookingTemplates = {};
}

extend(window.BookingTemplates, {
  booking_frontend_templates_picker: require('./templates/picker.html.mustache'),
  glive_booking_redesign_frontend_templates_book: require('./templates/book.html.mustache'),
  glive_booking_redesign_frontend_templates_date: require('./templates/date.html.mustache'),
  glive_booking_redesign_frontend_templates_datepicker: require('./templates/datepicker.html.mustache'),
  glive_booking_redesign_frontend_templates_deal_booker: require('./templates/deal/booker.html.mustache'),
  glive_booking_redesign_frontend_templates_info: require('./templates/info.html.mustache'),
  glive_booking_redesign_frontend_templates_quantities: require('./templates/quantities.html.mustache'),
  glive_booking_redesign_frontend_templates_quantity: require('./templates/quantity.html.mustache'),
  glive_booking_redesign_frontend_templates_quantitypicker: require('./templates/quantitypicker.html.mustache'),
  glive_booking_redesign_frontend_templates_section: require('./templates/section.html.mustache'),
  glive_booking_redesign_frontend_templates_sectionpicker: require('./templates/sectionpicker.html.mustache'),
  glive_booking_redesign_frontend_templates_time: require('./templates/time.html.mustache'),
  glive_booking_redesign_frontend_templates_timepicker: require('./templates/timepicker.html.mustache'),
  glive_booking_redesign_frontend_templates_times: require('./templates/times.html.mustache'),
});

const initialize = () => {
  const timer = new Timer('glive_booker_render');
  const gliveBookerDataElement = document.getElementById('gliveBookerData');
  const gliveBookerData = JSON.parse(gliveBookerDataElement ? gliveBookerDataElement.textContent : null);
  const eventPerformanceTracky = gliveBookerData ? gliveBookerData.eventPerformanceTracky : null;
  const gliveTranslationsElement = document.getElementById('gliveTranslations');
  const gliveTranslations = JSON.parse(gliveTranslationsElement ? gliveTranslationsElement.textContent : null);
  if (I18n.translations.js) {
    I18n.translations.js.modules.glive_booking_redesign = gliveTranslations;
  }

  gliveDealBookerInit(gliveBookerData)
    .then(() => {
      const gliveBookerRenderTracky = timer.complete();
      OptimizeSuite.TrackingHub.add('glive-booker-performance', {
        eventPerformanceTracky,
        gliveBookerRenderTracky,
      });
    })
    .catch(error => {
      OptimizeSuite.TrackingHub.add('glive-booker-error', {
        error,
      });
    });
};

documentReady.then(initialize);
